/*
 * Radio selection component
 */

import React from 'react';
import {
  Mode,
  castDataType,
  DataType,
} from '../common.jsx';

import Setting from './setting.jsx';
import Selection from './selection.jsx';

export default class RadioSelection extends Selection {

        static get TYPE() {
            return 'radio_selection';
        }

        static icon(){
            return <i className="fa fa-dot-circle-o"></i>;
        }

        static get TRANSLATED_ATTRIBUTES() {
            return {
                label: 'field_default_label',
                description: null,
                help: null,
                blankOptionLabel: 'select_blank_radio_default',
                changeConfirmText: null
            };
        }

        static defaultContent(language) {
            return Object.assign(super.defaultContent(language), {
                includeBlank: false,
                blankOptionLabel: 'blankOptionLabel'
            });
        }

        viewModeWholeScope() {
            return true;
        }

        renderSettings() {
            return (
                <div>
                    {this.isDatagridContextAvailable() && this.renderDatagridContextSettings()}
                    {super.renderSettings()}
                    {this.props.content.required ? '' : <Setting.Checkbox name="includeBlank" label={I18n.t('field_include_blank', {scope: 'fe'})} value={this.props.content.includeBlank} onChange={this.updateSettings} />}
                    {(this.props.content.required || !this.props.content.includeBlank) ? '' : <Setting.TextField name="blankOptionLabel" label={I18n.t('select_blank_option_label', {scope: 'fe'})} value={this.getText('blankOptionLabel')} onChange={this.updateSettings} />}
                </div>
            )
        }

        renderOptions() {
            let options = this.getOptions().map((o, i) => {
                let isChecked = this.getAnswer() === o.value;
                let hiddenOption = null;

                if (isChecked && this.isReadOnlyAnswer()) {
                    hiddenOption = <input type="hidden" name={this.fullFieldName()} defaultValue={o.value} />
                }
                return (
                    <label className="box-text-align" key={i}>
                        {hiddenOption}
                        <input type="radio" key={o.value}
                            className={this.isReadOnlyAnswer() ? 'locked' : ''}
                            name={this.fullFieldName()}
                            defaultValue={o.value}
                            checked={isChecked}
                            onChange={(e) => this.updateAnswer(e.target.value)}
                            disabled={this.props.mode != Mode.FILL || this.isReadOnlyAnswer()} />
                        {this.renderOption(o)}
                    </label>
                );
            });

            let clearButton = <a style={{textTransform: 'uppercase', fontSize: '1rem'}}
                                href='#'
                                onClick={this.clearSelection.bind(this)}>
                                {I18n.t('clear_selection', {locale: this.props.language})}
                                </a>

            return (
                <div className="options">
                    {(this.props.content.required || !this.props.content.includeBlank) ? '' : <label>
                        <input type="radio"
                            className={this.isReadOnlyAnswer() ? 'locked' : ''}
                            name={this.fullFieldName()}
                            disabled={this.props.mode != Mode.FILL || this.isReadOnlyAnswer()}
                            value=""
                            onChange={(e) => this.updateAnswer(e.target.value)}
                            checked={this.getRawAnswer() === ""} />
                            {this.getText('blankOptionLabel')}
                    </label> }
                    {options.length > 0 ? options : (<p><em>{I18n.t('no_options', {scope: 'fe', locale: this.props.language})}</em></p>)}
                    {this.props.mode != Mode.FILL || this.isReadOnlyAnswer() ? null : clearButton}
                </div>

            );
        }

        beforeUpdateSettings(content) {
            super.beforeUpdateSettings(content);
            content.includeBlank = castDataType(content.includeBlank, DataType.BOOLEAN);
            if (content.required) {
                content.includeBlank = false;
            }
        }

        clearSelection(e) {
            this.updateAnswer("");
            e.preventDefault();
            e.stopPropagation();
            return false;
        }
}
